import {useEffect, useState} from "react";
import {Card, Col, Row, Statistic, Table, Tag, Progress} from "antd";
import service from "../api/FetchInterceptor";

const statusColors = {
    submitted: "orange",
    in_progress: "blue",
    treated: "default",
    withdraw: "green",
    // waiting_validation: "orange",
    // validated: "green",
    // pre_closed: "gold",
    // closed: "default",
    // classified: "default",
    // sent: "purple",
};

const statCardStyles = {
    total: {border: "#8c8c8c", background: "#e8ddddff", value: "#595959"},
    submitted: {border: "#d46b08", background: "#eccb82ff", value: "#d46b08"},
    inProgress: {border: "#1677ff", background: "#a8d0eeff", value: "#1677ff"},
    readyToWithdraw: {border: "#389e0d", background: "#d3f2b4ff", value: "#389e0d"},
};

const DossierDashboard = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        service({
            method: "GET",
            url: "dossiers/dashboard",
        }).then((response) => {
            setData(response);
        });
    }, []);

    if (!data) return null;

    const {stats, statusBreakdown} = data;

    return (
        <div>
            <Row gutter={16}>
                <Col span={6}>
                    <Card
                        style={{
                            background: statCardStyles.total.background,
                        }}
                    >
                        <Statistic title="Total dossiers" value={stats.total} />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card
                        style={{
                            background: statCardStyles.submitted.background,
                        }}
                    >
                        <Statistic
                            title="En attente de traitement"
                            value={stats.submitted}
                            valueStyle={{color: "#d46b08"}}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card
                        style={{
                            background: statCardStyles.inProgress.background,
                        }}
                    >
                        <Statistic
                            title="En cours de traitement"
                            value={stats.inProgress}
                            valueStyle={{color: "#1677ff"}}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card
                        style={{
                            background: statCardStyles.readyToWithdraw.background,
                        }}
                    >
                        <Statistic
                            title="Prêts à retirer"
                            value={stats.readyToWithdraw}
                            valueStyle={{color: "#389e0d"}}
                        />
                    </Card>
                </Col>
            </Row>

            <Card title="Répartition par statut" className="mt-4">
                {statusBreakdown.map((row) => (
                    <div key={row.status_ac} className="mb-3">
                        <div style={{display: "flex", justifyContent: "space-between", marginBottom: 4}}>
                            <span>{row.statusAcLabel}</span>
                            <span>{row.total}</span>
                        </div>
                        <Progress
                            percent={Math.round((row.total / stats.total) * 100)}
                            strokeColor={statusColors[row.status_ac] || "#d9d9d9"}
                            showInfo={false}
                            size="small"
                        />
                    </div>
                ))}
            </Card>
        </div>
    );
};

export default DossierDashboard;